// The memory tools wrap read output as `<memory id="agtmemsetvn_...">...</memory>` with one
// `<memory_file path="..." id="agtmemvn_...">` per file. ListMemoryFiles uses self-closing,
// path-only memory_file elements. Paths are not escaped, so match them lazily and anchor the
// closing quote on the opening tag's known tail at the end of its line; quotes inside a path then
// remain part of the match.
const MEMORY_SET_VERSION_ID_RE = /<memory\s+id="([^"]*)"/;
const MEMORY_FILE_RE =
  /^<memory_file\s+path="(.*?)"(?:\s+id="[^"]*"(?:\s+truncated_chars="\d+")?>|\s+\/>)$/gm;

export interface ParsedMemoryOutput {
  // The whole-memory set version API id, or null when absent/unknown ("none").
  versionId: string | null;
  paths: Array<string>;
}

/**
 * Pull the set version id and file paths out of a memory tool's XML output. Returns null when the text
 * is not recognizably memory output.
 */
export function parseMemoryToolOutput(responseText: string | null | undefined): ParsedMemoryOutput | null {
  if (responseText == null || !responseText.includes('<memory')) {
    return null;
  }
  const versionIdMatch = MEMORY_SET_VERSION_ID_RE.exec(responseText);
  if (versionIdMatch == null) {
    return null;
  }
  const rawVersionId = versionIdMatch[1];
  const versionId = rawVersionId && rawVersionId !== 'none' ? rawVersionId : null;
  const paths = new Set<string>();
  for (const fileMatch of responseText.matchAll(MEMORY_FILE_RE)) {
    const path = fileMatch[1];
    if (path) {
      paths.add(path);
    }
  }
  return {versionId, paths: [...paths]};
}
